// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__3Luci","editor":"styles_editor__1VJiQ","errorBox":"styles_errorBox__251uy"};